import {
  useAdGroupSelection,
  useAdSelection,
} from "../hooks/useAdsCampaignSelection";
import {
  AdGroupSelectionContext,
  AdSelectionContext,
} from "../hooks/requiredAdsCampaignSelection";

const AdGroupSelectionGate = ({ children }) => {
  const selection = useAdGroupSelection();
  if (!selection.isReady) {
    return null;
  }
  return (
    <AdGroupSelectionContext.Provider value={selection}>
      {children}
    </AdGroupSelectionContext.Provider>
  );
};

const AdSelectionGate = ({ children }) => {
  const selection = useAdSelection();
  if (!selection.isReady) {
    return null;
  }
  return (
    <AdSelectionContext.Provider value={selection}>
      {children}
    </AdSelectionContext.Provider>
  );
};

export default AdGroupSelectionGate;
export { AdGroupSelectionGate, AdSelectionGate };
